import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WhyGetProtectedPathType } from '@common/util-models';

@Component({
  selector: 'sales-why-get-protected',
  templateUrl: './why-get-protected.component.html',
  styleUrls: ['./why-get-protected.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhyGetProtectedComponent {
  @Input() set areaName(setAreaName: WhyGetProtectedPathType | null) {
    if (setAreaName) {
      this.area = setAreaName;
    }
  }
  @Input() set clientName(setClientName: string | null | undefined) {
    if (setClientName) {
      this.client = setClientName;
    }
  }

  client = 'Domestic & General';
  area: WhyGetProtectedPathType = 'why_get_protected';
}
